import { LinkBuilder } from './link-types';

const template = require('./link.hbs');

module.exports = Backbone.View.extend({
  mode: 'url',

  isEditing: false,

  selectedUrlType: undefined,
  selectedPage: undefined,

  events: {
    'click .apply.btn': 'applyEvent',
    'click .remove.btn': 'removeEvent',
    'click .edit.btn': 'editEvent',
    'click [type=radio]': 'toggleEvent',
    'change [name="url-type"]': 'changeUrlTypeEvent',
    'keyup [name=url]': 'inputChangeEvent'
  },

  inputChangeEvent: function () {
    const element = this.$el.find('[name=url]').get(0);

    LinkBuilder.handleInputChange(element, this.selectedUrlType);
  },

  changeUrlTypeEvent: function (event) {
    const selectedUrlType = event.currentTarget.value;
    const element = this.$el.find('[name=url]').get(0);

    this.selectedUrlType = selectedUrlType;

    LinkBuilder.changeInputType(element, selectedUrlType);
  },

  removeEvent: function () {
    this.canvas.removeHyperlink();
  },

  editEvent: function () {
    const isAnchorMode = this.mode === 'anchor';

    this.render({
      isSet: false
    });

    this.isEditing = true;

    this.$el.find('[name=url]').toggleClass('disabled', isAnchorMode);
    this.$el.find('[name=anchor]').toggleClass('disabled', !isAnchorMode);

    this.$el.find('[name="url-type"]').toggleClass('disabled', isAnchorMode);
    this.$el.find('[name="link-type"]').toggleClass('disabled', !isAnchorMode);
  },

  applyEvent: function () {
    const inputTarget = this.mode === 'url' ? '[name="url"]' : '[name="anchor"]';
    const value = this.$el.get(0).querySelector(inputTarget).value;
    const selectedType = this.getSelectedUrlType(value);
    const link = LinkBuilder.buildLink(selectedType, value);
    if (!link) return;

    if (this.isEditing) {
      this.canvas.removeHyperlink();
    }
    this.canvas.makeHyperlink(link);

    this.isEditing = false;

    INKIVE.DesignFacade.trigger('link.update');
    this.render();
  },

  toggleEvent: function (event) {
    const selectedOption = $(event.currentTarget).attr('value');
    const isChecked = $(event.currentTarget).is(':checked');

    if (isChecked) {
      this.mode = selectedOption;
    }

    this.$el.find('[name=url],[name=anchor]').addClass('disabled');
    this.$el.find('[name="' + selectedOption + '"]').toggleClass('disabled', !isChecked);
    this.$el.find('[name="url-type"]').toggleClass('disabled', selectedOption === 'anchor');

    const url = this.$el[0].querySelector('[name="url"]').value;
    const isSubmitAllowed = selectedOption === 'anchor' || LinkBuilder.isValidInput(url, this.selectedUrlType);

    const applyButton = this.$el[0].querySelector('.apply');
    applyButton.classList.toggle('disabled', !isSubmitAllowed);
  },

  initialize: function (options) {
    this.href = options.href;
    this.canvas = options.canvas;
    this.mode = LinkBuilder.getLinkType(this.href) === 'anchor' ? 'anchor' : 'url';

    this.render();
  },

  getSelectedUrlType: function (url) {
    if (this.mode === 'anchor') return 'anchor';

    return this.selectedUrlType || LinkBuilder.getLinkType(url) || LinkBuilder.urlTypes[0].value;
  },

  render: function (options) {
    const anchor = this.href && this.href.indexOf('#') === 0 && this.href.replace('#', '');
    const url = !anchor && this.href;
    const isSet = options?.isSet ?? (anchor || url);
    this.selectedUrlType = this.getSelectedUrlType(this.href);
    const urlTypes = LinkBuilder.urlTypes.map((urlType) => {
      return {
        ...urlType,
        selected: this.selectedUrlType === urlType.value
      };
    });
    const pages = LinkBuilder.getPages().map(page => ({
      value: page,
      selected: page === anchor
    }));

    const html = template({
      anchor,
      url: LinkBuilder.getLinkValue(url),
      is_set: isSet,
      is_valid: LinkBuilder.isValidInput(url, this.selectedUrlType),
      hide_pages: INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.RESTRICTED_DESIGN ||
        INKIVE.C.BOOK.num_pages === 1,
      is_desygner: INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.DESYGNER_DESIGN,
      pages,
      urlTypes,
      selectedType: this.selectedUrlType
    });

    this.$el.html(html);
    anchor && this.$el.find('[name=anchor]').val(anchor);

    this.isEditing = false;
  }
});
